export default "__VITE_ASSET__DbKUMaae__"